<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #real_name>
        <a-input
          v-decorator="[
            'real_name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入姓名',
                },
              ],
            },
          ]"
          placeholder="请输入姓名"
        />
      </template>
      <template #sex>
        <a-select
          v-decorator="[
            'sex',
            { rules: [{ required: true, message: '请选择性别' }] },
          ]"
          placeholder="请选择性别"
        >
          <a-select-option
            :value="0"
          >
            保密
          </a-select-option>
          <a-select-option
            :value="1"
          >
            女
          </a-select-option>
          <a-select-option
            :value="2"
          >
            男
          </a-select-option>
        </a-select>
      </template>
      <template #phone>
        <a-input
          v-decorator="['phone',{rules: [
            { required: true, message: '请输入手机号码' },
            {
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
              message: '请输入正确的手机号码',
            },
          ],}]"
          placeholder="请输入手机号码"
        />
      </template>
      <template #provinceCity>
        <client-province-city
          v-decorator="[
            'provinceCity',

          ]"
        />
        <!-- {
              rules: [{ required: true, validator: checkProvinceCity }],
            }, -->
      </template>
      <template #address>
        <a-textarea
          v-decorator="['address', {
            rules: [{ required: true,message:'请输入详细地址' }],
          },]"
          placeholder="请输入详细地址"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>
<script>
import ClientProvinceCity from '../components/ProvinceCity';
import {
  contactFormData,
} from '../data/index';
export default{
  components: {ClientProvinceCity},
  props: ['title', 'visible'],
  data(){
    return{
      formData: contactFormData,
    };
  },
  methods: {
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      if(value.province > 4){
        if (!value || !value.city) {
          error.push('城市');
        }
      }else{
        value.city = '';
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
<style lang="less" scoped>

</style>